import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';

const FAQs = () => {
  const [openSection, setOpenSection] = useState('general');
  const [openQuestions, setOpenQuestions] = useState({});

  const toggleQuestion = (id) => {
    setOpenQuestions(prev => ({ ...prev, [id]: !prev[id] }));
  };

  const faqSections = {
    general: {
      title: 'General Queries',
      questions: [
        {
          id: 'what-is',
          question: 'What is Panchali Design Hub?',
          answer: 'Panchali Design Hub is a premium boutique offering contemporary Indian ethnic wear, combining traditional craftsmanship with modern design sensibilities.'
        },
        {
          id: 'store-location',
          question: 'Where is your store located?',
          answer: 'Our flagship store is located in [Address]. We also serve customers nationwide through our online store.'
        }
      ]
    },
    orders: {
      title: 'Orders & Shipping',
      questions: [
        {
          id: 'payment-methods',
          question: 'What payment methods do you accept?',
          answer: 'We accept all major credit cards, UPI, net banking, and popular digital wallets.'
        },
        {
          id: 'shipping-time',
          question: 'How long does shipping take?',
          answer: 'Domestic orders typically take 5-7 business days. Express delivery (2-3 days) is available for select locations.'
        }
      ]
    },
    returns: {
      title: 'Returns & Refunds',
      questions: [
        {
          id: 'return-policy',
          question: 'What is your return policy?',
          answer: 'We offer a 30-day return policy for unused items in original packaging. Custom-made items are non-returnable.'
        },
        {
          id: 'refund-process',
          question: 'How long does the refund process take?',
          answer: 'Refunds are processed within 5-7 business days after we receive and inspect the returned item.'
        }
      ]
    }
  };

  return (
    <>
      <Helmet>
        <title>FAQs | Panchali Design Hub</title>
        <meta name="description" content="Frequently Asked Questions about Panchali Design Hub's products, services, and policies" />
      </Helmet>

      <div className="max-w-4xl mx-auto px-4 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <h1 className="text-3xl font-light mb-4">Frequently Asked Questions</h1>
          <div className="w-24 h-[2px] bg-gradient-to-r from-indigo-900 to-transparent mx-auto"></div>
        </motion.div>

        <div className="space-y-8">
          {Object.entries(faqSections).map(([key, section]) => (
            <motion.div
              key={key}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="bg-white rounded-xl shadow-sm overflow-hidden"
            >
              <button
                onClick={() => setOpenSection(openSection === key ? null : key)}
                className="w-full px-6 py-4 flex justify-between items-center bg-gray-50"
              >
                <h2 className="text-xl font-medium text-gray-900">{section.title}</h2>
                {openSection === key ? <FiChevronUp /> : <FiChevronDown />}
              </button>

              {openSection === key && (
                <div className="p-6 space-y-4">
                  {section.questions.map((item) => (
                    <div key={item.id} className="border-b border-gray-100 last:border-0 pb-4 last:pb-0">
                      <button
                        onClick={() => toggleQuestion(item.id)}
                        className="w-full text-left flex justify-between items-center py-2"
                      >
                        <span className="text-gray-900 font-medium">{item.question}</span>
                        {openQuestions[item.id] ? <FiChevronUp /> : <FiChevronDown />}
                      </button>
                      {openQuestions[item.id] && (
                        <p className="text-gray-600 mt-2 pl-4">{item.answer}</p>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </>
  );
};

export default FAQs;